"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var triggerListener_1 = __importDefault(require("../fn/triggerListener"));
var updateTriggers_1 = __importDefault(require("../fn/updateTriggers"));
var err_1 = __importDefault(require("../fn/err"));
var isWildcardPath_1 = require("../fn/isWildcardPath");
var listenerId = 0;
/**
 * on
 *
 * Adds a listener
 *
 * - when a listener is first added a check is made
 *   on the path and if it exists then the listener
 *   is executed (async!)
 */
var on = function (db) { return function (path, fn) {
    var obj = {
        path: path,
        fn: fn,
    };
    if (!(0, isFunction_1.default)(fn)) {
        (0, err_1.default)(db, "/err/types/on/1", obj);
        return;
    }
    /*
    if (fn.length !== 1) {
      err(db, '/err/types/on/1', obj)
      return
    }
    */
    listenerId += 1;
    if (!db.updates.fns[path]) {
        db.updates.fns[path] = {};
        db.updates.fns[path][listenerId] = fn;
        db.updates.cache[path] = {};
        (0, updateTriggers_1.default)(db, path);
    }
    else {
        db.updates.fns[path][listenerId] = fn;
    }
    if (!(0, isWildcardPath_1.isWildcardPath)(path)) {
        (0, triggerListener_1.default)(db, path);
    }
    var id = listenerId;
    return function unsubscribe() {
        if (db.updates.fns[path]) {
            delete db.updates.fns[path][id];
        }
        // Remove everything related to this path as no
        // more listeners exist
        if (Object.keys(db.updates.fns[path]).length === 0) {
            db.updates.fns[path] = null;
            delete db.updates.fns[path];
            db.updates.cache[path] = null;
            delete db.updates.cache[path];
            var triggers = db.updates.triggers;
            var key = void 0;
            var keys = Object.keys(triggers);
            var l = keys.length;
            var i = void 0;
            var arr = void 0;
            while (l--) {
                key = keys[l];
                arr = triggers[key];
                i = arr.indexOf(path);
                if (i !== -1) {
                    arr.splice(i, 1);
                }
                if (arr.length === 0) {
                    triggers[key] = null;
                    delete triggers[key];
                }
            }
        }
    };
}; };
exports.default = on;
//# sourceMappingURL=data:application/json;base64,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